<script>
import AppNavbar from '@/components/AppNavbar'
import ArticleCover from '@/components/ArticleCover'
import ArticleMore from '@/components/ArticleMore'
import ArticleSlider from '@/components/ArticleSlider'
import shareMixin from '@/mixins/shares'

export default {
	name: 'Article7',
	components: {
		AppNavbar,
		ArticleCover,
		ArticleMore,
		ArticleSlider,
	},
	mixins: [shareMixin],
	head: {
		title: {
			inner: 'Все зло от людей'
		},
		meta: [
			{p: 'og:title', c: 'Афиша Zombie: что делать, если вас предал лучший друг?'},
			{p: 'og:description', c: 'Гид по персонажам "Ходячих мертвецов", которые предали своих друзей и перешли на сторону зла.' },
			{p: 'og:image', c: '/static/share/7.jpg'},
			{p: 'og:site_name', c: 'Афиша Zombie'},
		]
	},
}
</script>



<template>
<div class="article">
	<app-navbar />
	<article-cover image="articles/7/cover.jpg">
		<h2 slot="title">Все зло от людей:</h2>
		<p slot="text">Что делать, если вас предал лучший друг?</p>
	</article-cover>

	<section class="text start">
		<div class="inner">

			<h2>Если в первом сезоне сериала основную опасность представляли вечно голодные зомби, то затем оказалось, что гораздо опаснее в мире «Ходячих мертвецов» сами люди, которые вроде бы должны объединиться перед лицом общей угрозы и взять в руки оружие. Но нет. Вспоминаем тех, кто в разное время пошел на предательство и навсегда запятнал свое честное человеческое имя.</h2>

		</div>
	</section>

	<article-slider id="7" />

	<section class="text footer">
		<div class="inner">
			Смотреть сериал можно в «Интерактивном ТВ Ростелеком».
			<br>
			Если нашествие зомби застало вас не дома, подключайте опцию «Мультискрин» —<br>с ней весь контент будет доступен не только на экране телевизора,<br>но и <a href="https://moscow.rt.ru/inttv" target="_blank" onclick="ga('send', 'event', 'link', 'article', 'rostelekom')">на сайте itv.rt.ru</a> или на вашем мобильном устройстве.
		</div>
	</section>

	<div class="footer-share clearfix">
		<div class="title">Поделиться статьей</div>
		<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
		<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
		<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
		<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
		<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
	</div>

	<div class="devider"></div>

	<section class="text more">
		<div class="inner">Читайте также</div>
	</section>

	<article-more :ids="[1, 4, 3]" />


</div>
</template>



<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article {
	background: #fff;
}

section {
	width: 96%;
	max-width: 1040px;
	margin: 0 auto;
}

section .inner {
	max-width: 740px;
}

section h2 {
	padding: 0;
	margin: 0;
	font-weight: normal;
	font-size: 20px;
	padding-bottom: 20px;
	line-height: 30px;
}

section h3 {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: bold;
	line-height: 27px;
}

section p {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: normal;
	line-height: 27px;
}

.start {
	padding-top: 40px;
}

.text {
	background: #fff;
}

.article-image {
	width: 100%;
	max-width: 740px;
	padding: 40px 0;
}

.footer {
	padding: 40px 0;
	font-weight: 400;
	font-style: italic;
	font-family: @fontLava;
	line-height: 27px;
	font-size: 18px;

	a {
		color: @red;
	}
}

.footer-share {
	width: 100%;
	max-width: 1040px;
	margin: 0 auto;

	.title {
		width: 260px;
		height: 60px;
		line-height: 60px;
		font-size: 13px;
		letter-spacing: 1.5px;
		text-align: center;
		text-transform: uppercase;
		color: #fff;
		background: @red;
		float: left;
	}

	a {
		width: 80px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

	a:last-child {
		border-right: none;
	}

	a:hover {
		background: @red;
	}

}

.devider {
	width: 100%;
	height: 5px;
	background: #090909;
	margin-top: 60px;
}

.more {
	color: @red;
	font-size: 30px;
	height: 80px;
	line-height: 80px;
}






@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.footer-share {

	.title {
		display: none;
	}

	a {
		width: 20vw;
		height: 20vw;
		text-align: center;
		line-height: 20vw;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

}

.devider {
	display: none;
}



}

</style>



// WEBPACK FOOTER //
// Article7.vue?2be45310